module.exports = __webpack_public_path__ + "static/logo-trees-for-future-white.197dfef1.png";